import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { queryClient } from './query-client';
import { OneSignalProvider } from './OneSignalProvider';

export function AppProvider({ children }) {
  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <OneSignalProvider>{children}</OneSignalProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </HelmetProvider>
  );
}
